import Modifier from 'ember-modifier';
import { registerDestructor } from '@ember/destroyable';

function cleanup(instance) {
  if (instance.isRegistered) {
    instance.unregister?.(instance.element);
    instance.isRegistered = false;
  }
}

export default class SortableModifier extends Modifier {
  isRegistered = false;
  element = null;
  unregister = null;

  constructor(owner, args) {
    super(owner, args);
    registerDestructor(this, cleanup);
  }

  modify(element, _positional, { enabled = true, register, unregister }) {
    this.element = element;
    this.unregister = unregister;

    if (enabled && !this.isRegistered) {
      register(element);
      this.isRegistered = true;
    } else if (!enabled && this.isRegistered) {
      unregister(element);
      this.isRegistered = false;
    }
  }
}
